import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '@lt/components';

import { Check } from '@lt/components/icons-react';
import Certificate from './Certificate';
import { NEW_CERTIFICATE_DESIGNS } from '../store/certificate/constants';

interface IDesignSelector {
  design: (typeof NEW_CERTIFICATE_DESIGNS)[keyof typeof NEW_CERTIFICATE_DESIGNS];
  setDesign: (
    design: (typeof NEW_CERTIFICATE_DESIGNS)[keyof typeof NEW_CERTIFICATE_DESIGNS],
  ) => void;
  disabled?: boolean;
}

const ActiveIcon = () => (
  <StyledActiveIcon>
    <Check width="12px" height="20px" />
  </StyledActiveIcon>
);

const DesignSelector = ({
  design,
  setDesign,
  disabled = false,
}: IDesignSelector) => (
  <StyledContainer>
    {Object.keys(NEW_CERTIFICATE_DESIGNS).map((designName) => {
      const isActive = design === NEW_CERTIFICATE_DESIGNS[designName];
      return (
        <StyledButton
          functional
          disabled={disabled}
          onClick={() => setDesign(NEW_CERTIFICATE_DESIGNS[designName])}
          isActive={isActive}
          key={designName}
        >
          {isActive && <ActiveIcon />}
          <StyledCertificate
            design={NEW_CERTIFICATE_DESIGNS[designName]}
            width={61}
            isPreview
          />
        </StyledButton>
      );
    })}
  </StyledContainer>
);

const StyledButton = styled(Button)`
  position: relative;
  padding: 6px;
  display: flex;
  box-sizing: border-box;
  width: 75px;
  justify-content: center;
  border-radius: 2px;

  ${(props) =>
    props.isActive &&
    css`
      border: 1px solid;
      border-color: ${({ theme }) => theme.colors.blue};
    `};
`;

const StyledActiveIcon = styled.div`
  position: absolute;
  z-index: 2;
  top: -10px;
  display: flex;
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 50%;
  box-shadow: 2px 3px 4px 0 rgba(23, 24, 26, 0.46);

  path {
    stroke: ${({ theme }) => theme.colors.white};
  }
`;

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

const StyledCertificate = styled(Certificate)`
  box-shadow: 0px 0px 5px 3px rgba(34, 60, 80, 0.12);
`;

export default DesignSelector;
